import { render } from "./ShipMenu.vue?vue&type=template&id=4cfcd1f0"
import script from "./ShipMenu.vue?vue&type=script&lang=js"
export * from "./ShipMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__